import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function QrEntry() {
  const { token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const [showFallback, setShowFallback] = useState(false);
  const [fallbackMessage, setFallbackMessage] = useState('');

  const resolvedToken = useMemo(() => {
    if (token) return token;
    const params = new URLSearchParams(location.search);
    const byQuery = params.get('qr') || params.get('token');
    if (byQuery) return byQuery;
    const match = window.location.href.match(/[0-9a-fA-F-]{36}/);
    return match ? match[0] : '';
  }, [location.search, token]);

  useEffect(() => {
    console.log('[QrEntry] mount', { token: resolvedToken || token, loading, hasUser: Boolean(user) });
    if (!resolvedToken) {
      navigate('/estate-sales-pipeline/sold-inventory', { replace: true });
      return;
    }
    setShowFallback(false);
    if (loading) return;
    if (!user) {
      localStorage.setItem('returnTo', `/i/${resolvedToken}`);
      navigate('/signin', { replace: true });
      return;
    }
    const target = `/estate-sales-pipeline/sold-inventory?qr=${encodeURIComponent(resolvedToken)}`;
    navigate(target, { replace: true });
    const retryTimer = setTimeout(() => {
      navigate(target, { replace: true });
    }, 1200);
    return () => clearTimeout(retryTimer);
  }, [resolvedToken, token, user, loading, navigate]);

  useEffect(() => {
    if (!resolvedToken) return;
    const timer = setTimeout(() => {
      setFallbackMessage('Still loading? Tap to open sold inventory.');
      setShowFallback(true);
    }, 2500);
    return () => clearTimeout(timer);
  }, [resolvedToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-6 bg-white rounded-lg shadow-md">
        <p className="text-lg text-gray-700">Opening sold inventory...</p>
        <div className="mt-4 animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
        {showFallback && (
          <button
            type="button"
            className="mt-6 px-4 py-2 rounded bg-blue-600 text-white text-sm"
            onClick={() => {
              if (!resolvedToken) return;
              navigate(
                `/estate-sales-pipeline/sold-inventory?qr=${encodeURIComponent(resolvedToken)}`,
                { replace: true }
              );
            }}
          >
            {fallbackMessage}
          </button>
        )}
      </div>
    </div>
  );
}

export default QrEntry;
